import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { user, UserManipulationViewModel } from "./userManipulation-viewModel"

export class UserManipulationView extends View<UserManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-579E4C86-11DE-4A80-9A0F-FCCC73A0020C"
    }
    loadHtml(): string {
        let element = require('./userManipulation.html').default;
        let style = require('./userManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set users(v: ObservableArray<user>) { this._users = v; } public get users(): ObservableArray<user> { return this._users;} private _users: ObservableArray<user>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    addNew(){
        this.dataContext.addNew();
    }

}
